import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SpacerModuleAnimation = () => {
  const containers = document.querySelectorAll(".spacer-module");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const applyAnimations = () => {
    if (window.innerWidth >= 1024) {
      containers.forEach((container) => {
        const spacerLine = container.querySelectorAll(".spacer-line");

        if (spacerLine.length) {
          gsap.to(spacerLine, {
            opacity: 1,
            width: "100%",
            duration: 1.5,
            ease: "power2.inOut",
            scrollTrigger: {
              trigger: container,
              start: "top 90%",
              once: true,
              fastScrollEnd: true,
            },
          });
        }
      });
    }
  };
  applyAnimations();
};

export default SpacerModuleAnimation;
